
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((4|48|97)9|156|360|676|787)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
